export const fieldValuesToUpperCase = (value, type) => {
  if (value) {
    switch (type) {
      case 'password':
      case 'number':
      case 'file':
        return value;
      default:
        return typeof value === 'string' || value instanceof String ? value.toUpperCase() : value;
    }
  }
};
